module.exports = __webpack_public_path__ + "img/business-card-1026403-min.1b2b0cab.jpg";